import { Scale } from '@se-admin/falcon';
import * as React from 'react';
import { LoadingSkeletonSection } from '../../../common/utils/loadingSkeletons.styles';
import { SaleCardVariant } from '../index';
import {
  ContentContainer,
  EndMessageDesktop,
  ImageLabelContainer,
  SaleCardWrapper,
} from '../SaleCard.styles';
import { AspectRatioWrapper, ButtonSkeleton } from './SaleCardSkeleton.styles';

interface ISaleCardSkeletonProps {
  variant: SaleCardVariant;
}

/**
 * Renders a component with animated skeleton of a sale card
 * used for loading
 */
export function SaleCardSkeleton({ variant }: ISaleCardSkeletonProps) {
  switch (variant) {
    case SaleCardVariant.small:
      return (
        <SaleCardWrapper variant={variant}>
          <AspectRatioWrapper>
            <LoadingSkeletonSection
              width="100%"
              height="100%"
              background={true}
              borderRadius={`${Scale.xxs} ${Scale.xxs} 0 0`}
            />
          </AspectRatioWrapper>
          <LoadingSkeletonSection
            width="80%"
            height={Scale.m}
            padding={`${Scale.m} ${Scale.s} ${Scale.s} ${Scale.s}`}
            background={true}
          />
          <LoadingSkeletonSection
            width="50%"
            height={Scale.l}
            padding={Scale.s}
            background={true}
          />
          <LoadingSkeletonSection
            width="30%"
            height={Scale.xxl}
            padding={`${Scale.s} ${Scale.s} ${Scale.m} ${Scale.s}`}
            background={true}
          />
        </SaleCardWrapper>
      );
    default:
      return (
        <SaleCardWrapper variant={variant}>
          <EndMessageDesktop saleCardVariant={SaleCardVariant.normal}>
            <LoadingSkeletonSection
              width="29%"
              height={Scale.m}
              padding={`${Scale.xxs} 0`}
              background={true}
              centered={false}
            />
          </EndMessageDesktop>
          <ImageLabelContainer variant={variant}>
            <LoadingSkeletonSection width="100%" height="272px" background={true} />
          </ImageLabelContainer>
          <ContentContainer variant={variant}>
            <LoadingSkeletonSection width="75%" height={Scale.m} background={true} />
            <LoadingSkeletonSection
              width="100%"
              height={Scale.l}
              marginTop={Scale.m}
              background={true}
            />
            <LoadingSkeletonSection
              width="80%"
              height={Scale.m}
              marginTop={Scale.m}
              background={true}
            />
            <LoadingSkeletonSection
              width="40%"
              height={Scale.m}
              marginTop={Scale.m}
              background={true}
            />
            <ButtonSkeleton />
          </ContentContainer>
        </SaleCardWrapper>
      );
  }
}
